import { render, staticRenderFns } from "./routerViewIndustry.vue?vue&type=template&id=ab72c132"
import script from "./routerViewIndustry.vue?vue&type=script&lang=js"
export * from "./routerViewIndustry.vue?vue&type=script&lang=js"
import style0 from "./routerViewIndustry.vue?vue&type=style&index=0&id=ab72c132&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab72c132')) {
      api.createRecord('ab72c132', component.options)
    } else {
      api.reload('ab72c132', component.options)
    }
    module.hot.accept("./routerViewIndustry.vue?vue&type=template&id=ab72c132", function () {
      api.rerender('ab72c132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/routerViewIndustry.vue"
export default component.exports